module.exports = __webpack_public_path__ + "static/media/jpl.e242c34f.pdf";